import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import {
  getDefaultApplicablePrepaidItem,
  getDefaultApplicablePrepaidPetItem,
  getDefaultDate,
  getDefaultSizeAlias,
  getDefaultStore,
} from "@utils/ipetbooking-get-default";

export default [
  // ===
  // 線上預約 內容頁
  // ===
  {
    path: '/store/:storeAlias/reservation/:reservationAlias',
    name: 'reservation-item',
    component: () => lazyLoadView(import('@views/Reservation/Item.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentReservationItem
          ] = await Promise.all([
            store.dispatch('merchant/fetchReservationItem', {
              reservationAlias: routeTo.params.reservationAlias,
              date: getDefaultDate(routeTo.query.date),
              prepaidOrderUuid: routeTo.query.prepaidId,
              scheduleItemId: routeTo.query.scheduleItemId || undefined,
              types: ['cosmetic']
            })
          ]);

          routeTo.params.reservationItem = currentReservationItem.items;

          if(!store.getters['auth/isLoggedIn']) {
            return next()
          }

          await store.dispatch('order/fetchApplicablePrepaidOrderList', {
            useCached: true
          });

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      liffShowMenu: false
    },
    props: (route) => ({
      reservationItem: route.params.reservationItem
    }),
  },
]
